<template>
    <div class="flex w-full flex-col gap-6">
        <div v-if="Object.keys(allergies).length || description || image && image.path" class="flex flex-col items-start justify-between gap-4">
            <div v-if="Object.keys(allergies).length || description" class="flex flex-col gap-4">
                <div class="flex flex-col gap-2">
                    <p v-if="description" class="text-xs font-bold text-gray-500 sm:text-sm" v-html="description" />
                    <Allergies v-if="Object.keys(allergies).length" :id="`${id}modal`" :allergies="allergies" />
                </div>
            </div>
            <ModalProductImage :image="image" class="aspect-[16/4] w-full overflow-hidden bg-gray-50" />
        </div>
        <div v-if="extras && Object.keys(extras).length" class="flex flex-col gap-4">
            <FormKit type="group" name="extras">
                <template v-for="extra in extras" :key="extra!.id">
                    <div v-if="shouldBeVisible(extra)" class="flex flex-col gap-2">
                        <Extra v-bind="extra" />
                    </div>
                </template>
            </FormKit>
        </div>
        <FormKit
            v-if="webshopSettings().isRemarksTurnedOn"
            v-model="productForm().currentProductWithSelectedExtras.note"
            type="textarea"
            name="note"
            :label="t('cart.note')"
            :help="`${productForm().currentProductWithSelectedExtras.note ? productForm().currentProductWithSelectedExtras.note.length : 0} / 255`"
            validation="length:0,255"
            validation-visibility="live"
            :validation-messages="{
                length: 'Note cannot be more than 255 characters.'
            }"
        />
    </div>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import Allergies from '~/components/Allergies.vue'
    import Extra from '~/components/Extra/Extra.vue'
    import ModalProductImage from '~/components/Modal/ModalProduct/ModalProductImage.vue'
    import { productForm } from '~/store/productForm'
    import { webshopSettings } from '~/store/webshopSettings'
    defineProps<ProductOrderBuddy>()
    const { t } = useI18n()
    function shouldBeVisible (extra: any) {
        if (extra?.isVisible === false) {
            return false
        } else {
            if (extra?.isConditional === false) {
                return true
            }
            return productForm().isExtraConditionMet(extra)
        }
    }
</script>
